import React, { useState, useEffect, useRef } from 'react';
import { FaRocket, FaHeart, FaGem, FaUsers, FaStar } from 'react-icons/fa';
import './Vision.css';

const Vision = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="vision" className="vision section" ref={sectionRef}>
      <div className="container">
        <div className={`vision-header ${isVisible ? 'fade-in' : ''}`}>
          <h2 className="heading-lg">
            מה <span className="gradient-text highlight-yellow">החזון</span> שלי?
          </h2>
        </div>

        <div className="vision-content">
          <div className={`vision-main ${isVisible ? 'slide-in-up' : ''}`}>
            <div className="vision-card">
              <div className="vision-icon">
                <FaRocket />
              </div>
              
              <div className="vision-text">
                <h3 className="vision-title">החזון שלי</h3>
                <p className="vision-description">
                  להנגיש את הסושיאל לכל בית עסק בישראל תוך שמירה והקפדה על 
                  <span className="highlight-text"> איכות, דיוק והפרטים הקטנים</span>. 
                  שירותיות ברמה גבוהה תוך שמירת היחודיות של בית העסק.
                </p>
              </div>
            </div>
          </div>

          <div className={`vision-values ${isVisible ? 'slide-in-left' : ''}`}>
            <h3 className="values-title">הערכים שמנחים אותי</h3>
            <div className="values-grid">
              <div className="value-item">
                <div className="value-icon">
                  <FaGem />
                </div>
                <h4 className="value-title">איכות ללא פשרות</h4>
                <p className="value-description">
                  כל פרויקט מקבל את מלוא תשומת הלב והמקצועיות
                </p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <FaHeart />
                </div>
                <h4 className="value-title">שירות אישי וחם</h4>
                <p className="value-description">
                  ליווי צמוד ואישי לכל לקוח לאורך כל הדרך
                </p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <FaUsers />
                </div>
                <h4 className="value-title">שמירת יחודיות</h4>
                <p className="value-description">
                  כל עסק הוא ייחודי ומקבל פתרון מותאם אישית
                </p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <FaStar />
                </div>
                <h4 className="value-title">מצוינות בביצוע</h4>
                <p className="value-description">
                  תוצאות מדידות ומוכחות שמדברות בעד עצמן
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={`vision-quote ${isVisible ? 'fade-in-delayed' : ''}`}>
          <blockquote className="quote-text">
            "אני מאמינה שכל עסק בישראל יכול להצליח ברשתות החברתיות, 
            צריך רק לדעת איך לספר את הסיפור הנכון בדרך הנכונה"
          </blockquote>
          <cite className="quote-author">- ליהי שירזי</cite>
        </div>
      </div>
    </section>
  );
};

export default Vision;
